import BrickMenu from "./BrickMenu";

// The configuration panel, floating over the wall preview.
const Menu = () => (
  <aside
    id="wall-menu"
    aria-label="Configuratie"
    className="absolute inset-y-3 left-3 z-10 flex w-[440px] max-w-[calc(100%-1.5rem)] flex-col overflow-hidden rounded-xl border bg-background shadow-lg"
  >
    <BrickMenu />
  </aside>
);

export default Menu;
